<template>
  <div>
    <Form
      inline
      class="bill-form"
      :label-width="120"
      label-position="right"
      @submit.native.prevent
    >
      <FormItem :label="$t('keyword')" style="width: 60%">
        <Input
          ref="input"
          v-model="keywords"
          :placeholder="$t('enter') + $t('keyword')"
          :disabled="disabled"
          @on-enter="enterClick(keywords)"
        >
        </Input>
      </FormItem>
      <!-- <FormItem style="width:15%;margin:0"> -->
      <Button type="success" @click="bulkAdd">
        {{ $t("BulkAdd") }}
      </Button>
      <Button style="margin-left: 10px" type="primary" @click="copy">
        {{ $t("copy") }}{{ $t("order_number") }}
      </Button>
      <!-- </FormItem> -->
      <FormItem
        :label="$t('whether') + $t('unpack') + $t('complete')"
        style="width: 100%"
      >
        <RadioGroup @on-change="unpackChange" v-model="isUnpack">
          <Radio label="YES" border>{{ $t("YES") }}</Radio>
          <Radio label="NO" border>{{ $t("NO") }}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :label="'Execl' + $t('BulkAdd')" style="width: 100%">
        <Row>
          <Col span="6"
            ><Button type="primary" @click="downloadTemp">
              {{ $t("download_tem") }}
            </Button></Col
          >
          <Col span="5"
            ><Upload
              accept=".xlsx,.xls"
              :format="['xlsx', 'xls']"
              :before-upload="handleUpload"
              action="#"
            >
              <Button type="success">
                {{ $t("Excel Batch add") }}
              </Button>
            </Upload></Col
          >
          <Col span="12">
            {{ $t("Pending create order") }}：
            <span style="color: #ff9900; margin-right: 10px">{{
              orderWait.waitNumber
            }}</span>
            <span @click="handleError">
              {{ $t("error create order") }}：
              <span style="color: #ff9900; margin-right: 10px">{{
                orderWait.error_number
              }}</span>
            </span>

            {{ $t("Finish time") }}：
            <span style="color: #19b16b; margin-right: 10px">{{
              orderWait.last_update_time
            }}</span>
            {{ $t("总申报价值") }}：
            <span style="color: red; margin-right: 10px">{{
              orderWait.values
            }}</span>
            {{ $t("总重量") }}：
            <span style="color: blue; margin-right: 10px">{{
              orderWait.check_weight
            }}</span>
          </Col>
        </Row>
      </FormItem>
    </Form>
    <Row :gutter="10" class="order-class">
      <Col span="24">
        <Table
          :columns="tableTitle"
          :data="tableData"
          height="200"
          border
          stripe
        ></Table>
        <p
          style="font-weight: bold;margin-top:10px;margin-right:10px;text-align:right;font-size:15px;font-"
        >
          {{ $tz("申报价值") }}：{{ isNaN(totalPrice) ? 0 : totalPrice }}
        </p>
      </Col>
    </Row>
    <Row :gutter="10" class="order-class sku-cnb">
      <Col
        span="6"
        v-for="(item, index) in list"
        :key="item.id"
        style="margin-bottom: 5px"
      >
        <Card :bordered="false" style="background: #e8eaec">
          <p slot="title" class="text-red">
            <span>{{ list.length - index }}</span>

            <!-- <span
              @click="delBtn(item.airway_number)"
              style="font-size: 14px; cursor: pointer"
              ><Icon type="md-close"
            /></span> -->
          </p>
          <p class="text-green">{{ item.airway_number }}</p>
        </Card>
      </Col>
    </Row>

    <Modal
      v-model="showModal"
      @on-cancel="closeModal"
      :footer-hide="false"
      :title="$t('BulkAdd')"
      width="800"
      class-name="vertical-center-modal"
    >
      <Form
        label-position="right"
        :model="bulkObj"
        :label-width="100"
        :rules="ruleFrom"
        ref="bulkObj"
      >
        <Row v-for="(item, idx) in bulkObj.sku" :key="idx" align="middle">
          <Col :span="7">
            <FormItem
              :label="'sku' + (idx + 1)"
              :prop="'sku[' + idx + '].bar_code'"
              :rules="{
                required: true,
                message: $t('enter') + 'sku',
                trigger: 'blur'
              }"
            >
              <Input
                v-model="item.bar_code"
                :placeholder="$t('enter') + 'sku'"
                @on-focus="focusClick(idx)"
                @on-blur="blurClick(item.bar_code, idx)"
                style="width: 100%"
              ></Input>
            </FormItem>
          </Col>
          <Col :span="7">
            <FormItem
              :label="'sku' + $t('noofpieces') + (idx + 1)"
              :prop="'sku.' + idx + '.number'"
              :rules="{
                required: true,
                type: 'number',
                message: $t('enter') + $t('order_t') + $t('noofpieces'),
                trigger: 'blur'
              }"
            >
              <InputNumber
                v-model="item.number"
                style="width: 100%"
                :min="1"
                :step="1"
                @on-blur="computeAmount"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col :span="7">
            <FormItem
              :label="$t('DeclaredValue') + (idx + 1)"
              :prop="'sku.' + idx + '.values'"
            >
              <InputNumber
                v-model="item.values"
                style="width: 100%"
                @on-blur="computeAmount"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col v-if="bulkObj.sku.length - 1 == idx" :span="1">
            <Icon
              @click="addSku"
              size="20"
              color="#19be6b"
              style="margin-left: 20px; margin-bottom: 24px; cursor: pointer"
              type="ios-add-circle"
            />
          </Col>
          <Col v-if="bulkObj.sku.length != 1" :span="1">
            <Icon
              @click="delSku(idx)"
              size="20"
              color="#ed4014"
              style="margin-left: 20px; margin-bottom: 24px; cursor: pointer"
              type="ios-remove-circle"
            />
          </Col>
        </Row>
        <!-- <FormItem>
          <Button type="success">Success</Button>
        </FormItem> -->
        <FormItem
          :label="$t('order_t') + $t('noofpieces')"
          prop="unpack_number"
        >
          <InputNumber
            v-model="bulkObj.unpack_number"
            :step="1"
            :min="1"
            style="width: 100%"
          ></InputNumber>
        </FormItem>
        <FormItem :label="$t('total_amount')">
          <Input v-model="total" disabled style="width: 100%"></Input>
        </FormItem>
      </Form>
      <div slot="footer" class="footer-modal">
        <Button type="primary" @click="confirmModal">
          {{ $t("confirm") }}
        </Button>
        <Button @click="closeModal">{{ $t("cancel") }}</Button>
      </div>
      <div
        v-if="progressNum && loading"
        style="
          transform: translate(0, 0);
          width: 100%;
          height: 100%;
          position: fixed;
          left: 0;
          top: 0;
          background-color: rgba(0, 0, 0, 0.3);
          color: white;
          z-index: 999999;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <Button loading shape="circle" type="primary"></Button>
        <div>loading...</div>
        <!-- <div style="width:400px;margin-top:200px">
          <Progress
            :percent="progressNum"
            :stroke-width="20"
            status="active"
            text-inside
          />
        </div> -->
      </div>
    </Modal>
    <div
      v-if="loading && !showModal"
      style="
        transform: translate(0, 0);
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.3);
        color: white;
        z-index: 999999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
    >
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
  </div>
</template>
<script>
import {
  getUnpackList,
  getSkuVoice,
  postUnpack,
  postUnpackBatch,
  postUnpackBatchNew,
  deleteUnpack,
  getUnpackStatus,
  postUnpackStatus,
  getUnpackOrder
} from "@/api/double/unpack";
import boxMes from "@/utils/message";
import copyClick from "@/utils/copyClick";
import { add, isRepeat } from "@/libs/tools";
import { read } from "@/libs/excel";
import format from "@/utils/format";
export default {
  inject: ["$page"],
  props: {
    itemId: {
      type: Number
    },
    statusId: {
      type: String
    }
  },
  data() {
    return {
      keywords: "",
      isUnpack: "",
      list: [],
      loading: true,
      disabled: false,
      autofocus: true,
      autofocus1: false,
      tableData: [],
      localSku: {},
      showModal: false,
      bulkObj: {
        sku: [
          {
            bar_code: "",
            number: 1,
            values: 0
          }
        ],
        // sku: "",
        unpack_number: 1
        // sku_number: 1
      },
      ruleFrom: {
        // sku: [
        //   {
        //     required: true,
        //     type: "string",
        //     message: this.$t("enter") + "sku",
        //     trigger: "blur"
        //   }
        // ],
        // unpack_number: [
        //   {
        //     required: true,
        //     type: "number",
        //     message:
        //       this.$t("enter") + this.$t("order_t") + this.$t("noofpieces"),
        //     trigger: "blur"
        //   }
        // ],
        sku_number: [
          {
            required: true,
            type: "number",
            message: this.$t("enter") + "sku" + this.$t("noofpieces"),
            trigger: "blur"
          }
        ]
      },
      totalPrice: "0.00",
      isBlur: true,
      isSub: false,
      isAdd: false,
      isDel: false,
      arr: [],
      succList: [],
      failList: [],
      progressNum: 0,
      orderWait: {
        waitNumber: 0,
        last_update_time: 0
      },
      setT: null,
      total: 0
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("barCode"),
        key: "bar_code",
        align: "center",
        minWidth: 130,
        tooltip: true
      });
      columns.push({
        title: this.$t("skuName"),
        key: "sku_name",
        align: "center",
        minWidth: 130,
        tooltip: true
      });
      columns.push({
        title: this.$t("order_goods"),
        key: "num",
        align: "center",
        minWidth: 130,
        tooltip: true
      });
      columns.push({
        title: this.$t("commodityValue"),
        key: "declaration_amount",
        align: "center",
        minWidth: 130,
        tooltip: true,
        render: (h, params) => {
          return h("Input", {
            attrs: {
              value: params.row.declaration_amount
            },
            on: {
              input: event => {
                this.tableData[params.index].declaration_amount = event;
                this.handleTotal();
              }
            }
          });
        }
      });
      columns.push({
        title: this.$t("operation"),
        key: "operation",
        align: "center",
        width: 80,
        tooltip: true,
        render: (h, params) => {
          return h(
            "Button",
            {
              attrs: {
                type: "error",
                size: "small"
              },
              on: {
                click: event => {
                  this.tableData.splice(params.index, 1);
                  this.handleTotal();
                }
              }
            },
            this.$t("delete")
          );
        }
      });
      return columns;
    }
  },
  mounted() {
    this.SearchSubmit();
  },
  beforeDestroy() {
    clearTimeout(this.setT);
  },
  methods: {
    handleError() {
      let airway_number = this.statusId;
      this.$page.getModal("errorOrder").open({}, function() {
        this.pageConfig.data.airway_number = airway_number;
        this.getList();
      });
    },
    computeAmount() {
      this.total = 0;
      console.log("chfua", this.total);
      this.bulkObj.sku.forEach(t => {
        if (t.values && t.number) {
          this.total += parseFloat((t.values * t.number).toFixed(2));
        }
      });
    },
    // 下载模板
    downloadTemp() {
      window.open(this.$globalUrl + "/static/templates/UploadUnpack.xlsx");
    },
    // 批量导入
    handleUpload(file) {
      console.log(file);
      let reader = new FileReader();
      //启动函数
      reader.readAsBinaryString(file);
      //onload在文件被读取时自动触发
      reader.onload = e => {
        try {
          let arr = [];
          let data = read(e.target.result, "binary").results;
          let headers = read(e.target.result, "binary").header;
          data.forEach(el => {
            if (el) {
              let obj = {};
              obj["airway_number"] = this.statusId;
              obj["bar_code"] = el[headers[0]];
              obj["bar_code_number"] = el[headers[1]];
              obj["values"] = el[headers[2]];
              obj["number"] = el[headers[3]];
              arr.push(obj);
            }
          });
          this.bulkAddFun(arr);
        } catch (error) {
          this.$Message.warning("文件类型不正确！");
        }
      };
      return false;
    },
    // 获取焦点时
    focusClick() {
      this.isBlur = false;
      this.isSub = false;
    },
    // 失去焦点判断sku
    blurClick(val, idx) {
      if (val) {
        getSkuVoice({ sku_code: val, order_id: this.itemId }).then(res => {
          this.isBlur = true;
          if (!res.data.status) {
            if (this.bulkObj.sku[idx]) {
              this.bulkObj.sku[idx].bar_code = "";
            }
            this.isDel = false;
          } else {
            if (this.isSub) {
              this.confirmModal();
            }
            if (this.isAdd) {
              this.addSku();
            }
            if (this.isDel === 0 || this.isDel) this.delSku(this.isDel);
          }
        });
      }
    },
    // 添加sku
    addSku() {
      this.isAdd = true;
      if (!this.isBlur) {
        return false;
      }
      this.bulkObj.sku.forEach(el => {
        for (const key in el) {
          if (el[key] === "") {
            this.isAdd = false;
          }
        }
      });
      if (this.isAdd) {
        this.bulkObj.sku.push({
          bar_code: "",
          number: 1,
          values: 0
        });
        this.isAdd = false;
      } else {
        this.$Message.error(
          "sku" + this.$t("information") + this.$t("unperfect")
        );
      }
    },
    // 删除sku
    delSku(idx) {
      console.log("idx", idx);

      this.isDel = idx;
      // if (!this.isBlur) {
      //   return false;
      // }
      this.bulkObj.sku.splice(idx, 1);
      this.isDel = false;
    },
    // 删除拆包
    delBtn(id) {
      this.$Modal.confirm({
        title:
          this.$t("whether") +
          this.$t("confirm") +
          this.$t("delete") +
          this.$t("orderNum") +
          "：" +
          id +
          "?",
        onOk: () => {
          deleteUnpack({ airway_number: id }).then(res => {
            if (res.data.code === 0) {
              this.SearchSubmit();
              this.$Message.success("删除成功");
            }
          });
        }
      });
    },
    // 批量添加方法
    bulkAddFun(obj) {
      postUnpackBatchNew(obj).then(res => {
        if (res.data.status) {
          this.$Message.success("正在生成中");
          this.getList(this.itemId);
          this.unpackOrder({ airway_number: this.statusId });
          this.bulkObj.sku.forEach(el => {
            el.bar_code = "";
          });
        } else {
          this.loading = false;
        }
      });
      // .finally(err => {
      //   this.loading = false;
      //   this.progressNum = 0;
      // });
      // postUnpackBatch(this.itemId, this.bulkObj).then(res => {
      //   if (res.data.code == 0 || res.data.status) {
      //     this.succList.push(res.data);
      //   } else {
      //     this.failList.push(res.data);
      //   }
      //   this.progressNum = Number(
      //     (
      //       this.progressNum +
      //       Number((100 / this.bulkObj.unpack_number).toFixed(2))
      //     ).toFixed(2)
      //   );
      //   if (num > 0) {
      //     this.bulkAddFun(num - 1);
      //   } else {
      //     this.$Message.info({
      //       background: true,
      //       content:
      //         "应创建订单:" +
      //         this.bulkObj.unpack_number +
      //         "条 ，成功：" +
      //         this.succList.length +
      //         "条" +
      //         "，失败：" +
      //         this.failList.length +
      //         "条",
      //       duration: 5
      //     });
      //     this.getList(this.itemId);
      //     this.bulkObj.sku.forEach(el => {
      //       el.bar_code = "";
      //     });
      //     this.succList = [];
      //     this.failList = [];
      //   }
      // });
    },
    // 批量添加提交
    confirmModal() {
      this.isSub = true;
      if (!this.isBlur) {
        return false;
      }
      this.$refs.bulkObj.validate(async valid => {
        if (valid) {
          this.isSub = false;
          if (isRepeat(this.bulkObj.sku, "bar_code")) {
            this.$Message.error("sku不能重复");
            return;
          }
          this.bulkObj.sku.forEach(el => {
            for (const key in el) {
              if (el[key] === "") {
                this.$Message.error(
                  "sku" + this.$t("information") + this.$t("unperfect")
                );
                return false;
              }
            }
          });
          this.loading = true;
          // this.showModal = false;
          // this.succList = [];
          // this.failList = [];
          this.progressNum = 1;
          let obj = {
            airway_number: this.statusId,
            bar_code: "",
            bar_code_number: "",
            number: this.bulkObj.unpack_number,
            values: ""
          };
          this.bulkObj["sku"].forEach(el => {
            obj.bar_code += obj.bar_code ? "," + el.bar_code : el.bar_code;
            obj.values += obj.values ? "," + el.values : el.values || "";
            obj.bar_code_number += obj.bar_code_number
              ? "," + el.number
              : el.number;
          });
          this.bulkAddFun([obj]);
        }
      });
    },
    closeModal() {
      this.$refs.bulkObj.resetFields();
      this.bulkObj = {
        sku: [
          {
            bar_code: "",
            number: 1,
            amount: 0
          }
        ],
        // sku: "",
        unpack_number: 1
        // sku_number: 1
      };
      this.arr = [];
      this.showModal = false;
    },
    bulkClick(val) {
      console.log("bulkClick", val);
    },
    // 批量添加
    bulkAdd() {
      this.showModal = true;
    },
    copy() {
      let data = [];
      this.list.map(item => {
        data.unshift(item.airway_number);
        return item.airway_number;
      });
      copyClick.copyToClipboard(data.join("\r\n"), this);
    },
    inputFocus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    handleTotal() {
      this.totalPrice = 0;
      console.log(this.totalPrice);
      this.tableData.forEach(item => {
        this.totalPrice = add(
          this.totalPrice,
          item.declaration_amount * item.num
        );
      });
      console.log(this.tableData, "e");
    },
    enterClick(val) {
      if (!val) {
        this.$Message["error"]({
          background: true,
          content: "内容不能为空",
          duration: 5
        });
        return;
      }
      if (val != "CREATEORDER") {
        this.keywords = "";
        this.disabled = true;
        this.autofocus = false;
        if (this.localSku.hasOwnProperty(val)) {
          this.totalPrice = "0.00";
          let flag = false;
          this.tableData.forEach(item => {
            if (
              item.bar_code == val.toUpperCase() ||
              item.bar_code == val.toLowerCase() ||
              item.bar_code == val
            ) {
              item.num += 1;
              flag = true;
              return;
            }
          });
          if (flag == false) {
            // let data = this.localSku[val].data.payload;
            this.localSku[val].data.payload.num = 1;
            this.tableData.push(this.localSku[val].data.payload);
          }
          this.handleTotal();
          this.resMsg(this.localSku[val]);
          return;
        }
        getSkuVoice({ sku_code: val, order_id: this.itemId }).then(res => {
          if (res.data.status) {
            this.totalPrice = "0.00";
            res.data.payload.num = 1;
            this.localSku[res.data.payload.bar_code] = res;
            let flag = false;
            this.tableData.forEach(item => {
              if (
                item.bar_code == val.toUpperCase() ||
                item.bar_code == val.toLowerCase() ||
                item.bar_code == val
              ) {
                item.num += 1;
                flag = true;
                return;
              }
            });
            if (flag == false) {
              this.tableData.push(res.data.payload);
            }
            this.tableData.forEach(item => {
              this.totalPrice = add(
                this.totalPrice,
                item.declaration_amount * item.num
              );
            });
          }
          this.resMsg(res);
        });
      } else {
        this.keywords = "";
        if (this.tableData.length == 0) {
          this.$Message["error"]({
            background: true,
            content: "商品不能为空",
            duration: 5
          });
          return;
        }
        let goods = [];
        this.tableData.map(item => {
          goods.push({
            invoiceName: item.sku_title,
            invoicePCS: item.num,
            invoiceInsValue: item.declaration_amount,
            invoiceHSCod: item.hs_code,
            invoiceDescription: item.bar_code,
            invoiceWeight: item.weight
          });
        });
        postUnpack(this.itemId, { goods: goods }).then(res => {
          this.resMsg(res);
          if (res.data.status) {
            this.tableData = [];
            this.inputFocus();
            this.list.unshift({
              airway_number: res.data.payload.orderId,
              id: this.list[0] ? this.list[0].id + 1 : 1
            });
            this.totalPrice = "0.00";

            // this.SearchSubmit();
          }
        });
      }
    },
    resMsg(res) {
      if (!res.data.status) {
        this.$Message["error"]({
          background: true,
          content: res.data.msg,
          duration: 5
        });
      } else {
        this.$Message["success"]({
          background: true,
          content: res.data.msg
        });
      }
      this.playMusic(res);
    },
    playMusic(res) {
      let audio = new Audio();
      audio.src = this.$globalUrl + res.data.payload.voice;
      audio.play();
      this.disabled = false;
      this.inputFocus();
    },
    getList(id) {
      this.inputFocus();
      this.loading = true;
      getUnpackList(id)
        .then(res => {
          if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.list = res.data.payload;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取拆包状态
    unpackStatus(id) {
      getUnpackStatus(id)
        .then(res => {
          if (!res.data.status) {
            boxMes.alertMes(res, this);
            return;
          }
          this.isUnpack = res.data.payload.isUnpack;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 是否拆包改变
    unpackChange(val) {
      postUnpackStatus({ id: this.itemId, isUnpack: val }).then(res => {
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.status ? "操作成功" : res.data.msg,
          duration: 5
        });
      });
    },
    // 获取拆包正在生成订单
    unpackOrder(data) {
      getUnpackOrder(data)
        .then(res => {
          if (!res.data.status) {
            boxMes.alertMes(res, this);
            return;
          }
          if (res.data.payload.last_update_time)
            res.data.payload.last_update_time = format.timeFormat(
              res.data.payload.last_update_time * 1000
            );
          this.orderWait = res.data.payload;
          if (res.data.payload["waitNumber"] > 0) {
            this.setT = setTimeout(() => {
              this.getList(this.itemId);
              this.unpackOrder({ airway_number: this.statusId });
              clearTimeout(this.setT);
            }, 5000);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    SearchSubmit() {
      this.getList(this.itemId);
      this.unpackStatus(this.itemId);
      this.unpackOrder({ airway_number: this.statusId });
    }
  }
};
</script>

<style scoped>
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
.bill-form .ivu-form-item {
  margin-bottom: 10px;
}
.ivu-card-head p,
.ivu-card-head-inner.text-red {
  width: 100%;
  color: red;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
.order-class {
  padding: 10px 0;
}
.text-green {
  color: #19be6b;
  font-weight: bold;
}
.ivu-card-head {
  border-bottom: 1px solid #fff !important;
}
.sku-cnb {
  height: 400px;
  overflow: auto;
  justify-content: flex-start;
}
</style>
